var _rect, _path, _rect2, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileAccountConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 36,
    height: 36,
    rx: 4,
    fill: "#6EEBD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7498 15.1389C11.3663 15.1389 11.0554 15.4498 11.0554 15.8333V24.1667C11.0554 24.5502 11.3663 24.8611 11.7498 24.8611H24.2498C24.6334 24.8611 24.9443 24.5502 24.9443 24.1667V15.8333C24.9443 15.4498 24.6334 15.1389 24.2498 15.1389H11.7498ZM9.6665 15.8333C9.6665 14.6827 10.5992 13.75 11.7498 13.75H24.2498C25.4004 13.75 26.3332 14.6827 26.3332 15.8333V24.1667C26.3332 25.3173 25.4004 26.25 24.2498 26.25H11.7498C10.5992 26.25 9.6665 25.3173 9.6665 24.1667V15.8333Z",
    fill: "#715FF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 14.5833,
    width: 10.8333,
    height: 1.66667,
    transform: "rotate(90 15.5 14.5833)",
    fill: "#715FF5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2060_7021",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 11,
    width: 16,
    height: 6
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6665 11.25H24.6665V14.5833H18.2379L9.6665 16.25V11.25Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2060_7021)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7397 12.6389C11.358 12.6389 11.0486 12.9498 11.0486 13.3333V21.6667C11.0486 22.0502 11.358 22.3611 11.7397 22.3611H21.76C22.1417 22.3611 22.4511 22.0502 22.4511 21.6667V13.3333C22.4511 12.9498 22.1417 12.6389 21.76 12.6389H11.7397ZM9.6665 13.3333C9.6665 12.1827 10.5947 11.25 11.7397 11.25H21.76C22.905 11.25 23.8332 12.1827 23.8332 13.3333V21.6667C23.8332 22.8173 22.905 23.75 21.76 23.75H11.7397C10.5947 23.75 9.6665 22.8173 9.6665 21.6667V13.3333Z",
    fill: "#715FF5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAccountConnect);
export default __webpack_public_path__ + "static/media/mobile-account-connect.e3cec5a59371f680eb2ab6e48231654a.svg";
export { ForwardRef as ReactComponent };